// Tiny global opener for the TradingView chart modal. Any component can call
// openTickerChart('AAPL') without prop-drilling or a context provider; the
// <TickerChart/> mounted once at the App root listens for the event.
export const TICKER_CHART_EVENT = 'chronos:open-ticker-chart';

export function openTickerChart(ticker: string): void {
  window.dispatchEvent(new CustomEvent(TICKER_CHART_EVENT, { detail: ticker }));
}
